import { render, staticRenderFns } from "./InputTags.vue?vue&type=template&id=ca9aded2&"
import script from "./InputTags.vue?vue&type=script&lang=js&"
export * from "./InputTags.vue?vue&type=script&lang=js&"
import style0 from "./InputTags.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports